import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Apps from './pages/Apps';
import Investors from './pages/Investors';
import Contact from './pages/Contact';
import Documentation from './pages/Documentation';
import HarvardOfBoulder from './components/harvard_of_boulder';
import './App.css';

// Component to render Header/Footer
const AppContent: React.FC = () => {
  return (
    <div className="dark min-h-screen bg-dark-900 text-white flex flex-col">
      <Header />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/apps" element={<Apps />} />
          <Route path="/investors" element={<Investors />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/documentation" element={<Documentation />} />
          <Route path="/harvard_of_boulder" element={<HarvardOfBoulder />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;